export default "__VITE_ASSET__DdHQtpad__"